/* eslint-disable max-len */
import { api, ApiAction, IApiOptions } from '../../utils/api/actions';
import { CustomAction } from '../../utils/types';
import { Constants } from './constants';

export type SetPlayers = ApiAction<typeof Constants.SET_PLAYER, void>;
export type SetSideOne = CustomAction<typeof Constants.SET_SIDE_ONE, boolean>;
export type SetSideTwo = CustomAction<typeof Constants.SET_SIDE_TWO, boolean>;

export const setPlayers = (sport: string, site: string, token: string, slate: string) => {
  let options: IApiOptions = {
    method: 'GET',
    route: '',
  };

  const route = '/api/playercompare/players';

  var ffSite = site?.toLowerCase() === "dk" && slate?.toLowerCase() === 'showdown' ? "dk_showdown" : site;

  options = {
    ...options,
    route,
    params: {
      sport,
      site: ffSite,
      token,
      slate
    },
  };

  return api(
    Constants.SET_PLAYER, {
    ...options,
  },
  );
};

export const setSideOne = (players: string[]) => ({
  type: Constants.SET_SIDE_ONE,
  payload: players,
});

export const setSideTwo = (players: string[]) => ({
  type: Constants.SET_SIDE_TWO,
  payload: players,
});


export const setResults = (sport: string, site: string, token: string, ids1: string[], ids2: string[], slate: string) => {
  let options: IApiOptions = {
    method: 'POST',
    route: '',
  };

  const route = '/api/playercompare/compare';

  var ffSite = site?.toLowerCase() === "dk" && slate?.toLowerCase() === 'showdown' ? "dk" : site;

  options = {
    ...options,
    route,
    params: {
      sport,
      site: ffSite,
      token,
      slate,
    },
    data: {
      ids1,
      ids2,
    }
  };

  return api(
    Constants.SET_RESULTS, {
    ...options,
  },
  );
};

export const setAuth = (sport: string, token: string) => {
  let options: IApiOptions = {
    method: 'GET',
    route: '',
  };

  const route = '/api/auth';

  options = {
    ...options,
    route,
    params: {
      sport,
      token,
      appName: 'playercompare',
    },
  };

  return api(
    Constants.SET_AUTH, {
    ...options,
  },
  );
};

export const getConfig = (sport: string) => {
  let options: IApiOptions = {
    method: 'GET',
    route: '',
  };

  const route = '/api/playercompare/config';

  options = {
    ...options,
    route,
    params: {
      sport
    }
  };

  return api(
    Constants.GET_CONFIG, {
    ...options,
  },
  );
}